<template>
Error
</template>

<script setup>
const redirectPath = '/';

clearError({ redirect: redirectPath });
</script>